import { Component, OnInit, ViewEncapsulation, input } from '@angular/core';




@Component({
    selector: 'app-my-summary-view',
    templateUrl: './my-summary-view.component.html',
    styleUrls: [
        '../../../../../../../../../src/assets/css/global-styles.scss',
        '../../../../../../../../../src/assets/css/ds-core.css',
        '../../../../../../../../../src/assets/css/ds-button.css',
        '../../../../../../../../../src/assets/css/ds-card.css',
        '../../../../../../../../../src/assets/css/ds-form.css',
        '../../../../../../../../../src/assets/css/ds-modal.css',
        '../../../../../../../../../src/assets/css/ds-step-indicator.css',
        '../../../../../../../../../src/assets/css/ds-tabs.css',
        '../../../../../../../../../src/assets/css/ds-tile.css',
        './my-summary-view.component.css',
    ],
    encapsulation: ViewEncapsulation.Emulated,
    imports: []
})
export class MySummaryViewComponent implements OnInit {


  constructor() { }
readonly dataLst = input<any[]>(undefined);
  ngOnInit(): void {
   


  }


}
